import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Button, ThemeProvider } from '@mui/material';
import OutagesDialog from '../components/OutagesDialog';

export function renderButtonField(field, theme, cell, graph) {
  const container = document.createElement('div');

  function ButtonWithDialog() {
    const [open, setOpen] = useState(false);

    const outages = cell.get('outages');
    const saveOutages = (rows) => {
      if (field.readOnly) return;
      cell.set('outages', rows);
      graph.trigger('change:cell', cell);

      const updatedRows = rows.map((r) => {
        let entityValue;
        if (cell.attributes.type === 'standard.Link') {
          const sourceId = cell.attributes.source?.id;
          const targetId = cell.attributes.target?.id;
          const sourceCell = graph.getCell(sourceId);
          const targetCell = graph.getCell(targetId);

          const sourceName = sourceCell?.get?.('cellName') || sourceId;
          const targetName = targetCell?.get?.('cellName') || targetId;

          entityValue = `T_${sourceName}_${targetName}`;
        } else {
          const fullName = cell.attributes.customAttributes.fullName;
          if (fullName) {
            // Normalize "Tri_" prefix to "Sorter_" for simulation compatibility
            const triLike = /^Tri[^_]*_/i;
            const normalized = triLike.test(fullName) ? fullName.replace(triLike, 'Sorter_') : fullName;
            entityValue = `${normalized}${cell.get?.('cellName') || cell.attributes.cellName}`;
          } else {
            entityValue = undefined;
          }
        }

        return {
          ...r,
          entity: entityValue,
        };
      });

      const tables = graph.get('tables') || {};
      const existing = Array.isArray(tables.outages) ? tables.outages : [];
      const cleaned = existing.filter((o) => o.cellId !== cell.id);
      const toAdd = updatedRows
        .filter((r) => Object.values(r).some((val) => val !== '' && val != null))
        .map((r) => ({ cellId: cell.id, ...r }));

      tables.outages = [...cleaned, ...toAdd];
      graph.set('tables', tables);
    };

    return (
      <ThemeProvider theme={theme}>
        <Button
          variant="contained"
          className="select-destination-btn"
          onClick={field.readOnly ? undefined : () => setOpen(true)}
          disabled={field.readOnly}
        >
          {field.label || 'Button'}
        </Button>
        {!field.readOnly && (
          <OutagesDialog
            open={open}
            outages={outages}
            onClose={() => setOpen(false)}
            onSave={saveOutages}
            cell={cell}
          />
        )}
      </ThemeProvider>
    );
  }

  ReactDOM.render(<ButtonWithDialog />, container);
  return container;
}
